// Service Worker Registration for Reify Systems PWA
// Forces immediate update detection and cache clearing

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = '/service-worker.js';

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('[PWA] Service Worker registered');

          // Force update check immediately and every 30 seconds
          registration.update();
          setInterval(() => registration.update(), 30 * 1000);

          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (!installingWorker) return;

            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                // Force the new SW to activate immediately
                installingWorker.postMessage('skipWaiting');
                console.log('[PWA] New version found, activating...');
              }
            };
          };
        })
        .catch((error) => {
          console.error('[PWA] SW registration failed:', error);
        });

      // When a new SW takes over, reload to get fresh assets
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          console.log('[PWA] New SW active, reloading page');
          window.location.reload();
        }
      });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error('[PWA] Unregister failed:', error));
  }
}
